var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page"},[(!_vm.isLoading && !_vm.is_homepage_v2_exp)?_c('HomeV2'):_vm._e(),_vm._v(" "),(!_vm.isLoading && _vm.is_homepage_v2_exp)?_c('HomeV2Exp'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }